import moment from 'moment'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './OrangeTimer.scss'

export default class OrangeTimer extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        serverDelta: PropTypes.number.isRequired,
        isSmall: PropTypes.bool,
        endDate: PropTypes.number.isRequired,
        showDays: PropTypes.bool,
        onExpired: PropTypes.func,
        glowAt: PropTypes.number,
    }

    constructor(props) {
        super(props)

        this.MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000
    }

    componentWillMount() {
        this.update(true)
    }

    update(isFirstTime) {
        const milliseconds = Math.max(moment.utc(this.props.endDate).diff(moment().add(this.props.serverDelta)), 0)
        if (milliseconds === 0 && !!this.props.onExpired) {
            this.props.onExpired()
        }

        this.timeoutId = setTimeout(this.update.bind(this), 1000)

        if (isFirstTime && this.props.glowAt) {
            this.timeoutGlowId = setTimeout(() => {
                this.setState({
                    showGlow: true,
                })
            }, milliseconds - this.props.glowAt)
        }

        this.setState({
            milliseconds,
        })
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId)
        }
        if (this.timeoutGlowId) {
            clearTimeout(this.timeoutGlowId)
        }
    }

    render() {
        const baseClassName = classNames(styles.base, this.props.className, {
            [styles.base__isSmall]: this.props.isSmall,
            [styles.base__isBig]: !this.props.isSmall,
        })
        const timeLeft = moment.utc(this.state.milliseconds)
        const days = Math.floor(this.state.milliseconds / this.MILLISECONDS_IN_DAY)
        if (days === 0 || !this.props.showDays) {
            const hours = days * 24 + timeLeft.hours()
            return (
                <div className={baseClassName}>
                    {this.state.showGlow && (
                        <div className={styles.showGlow} />
                    )}
                    <FormattedMessage
                        id='shop.countdown.no.days'
                        defaultMessage='{hours} : {minutes} : {seconds}'
                        values={{
                            hours: hours < 100 ? `0${days * 24 + timeLeft.hours()}`.slice(-2) : hours,
                            minutes: `0${timeLeft.minutes()}`.slice(-2),
                            seconds: `0${timeLeft.seconds()}`.slice(-2),
                        }}
                    />
                </div>
            )
        }

        return (
            <div className={baseClassName}>
                {this.state.showGlow && (
                    <div className={styles.showGlow} />
                )}
                <FormattedMessage
                    id='shop.countdown'
                    defaultMessage='{days}д : {hours} : {minutes} : {seconds}'
                    values={{
                        days,
                        hours: `0${timeLeft.hours()}`.slice(-2),
                        minutes: `0${timeLeft.minutes()}`.slice(-2),
                        seconds: `0${timeLeft.seconds()}`.slice(-2),
                    }}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/OrangeTimer/OrangeTimer.jsx